import React from 'react';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import VideoModal from '../shared/VideoModal';
import SafeComponent from '../shared/SafeComponent';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { CLICKED_BRAND_VIDEO } from '../../utils/biEvents/events/mixPanelEvents';
import { videoUrl, pictureData, imgSrc } from './config';

import './style.scss';

const reportBi = () => {
    sendMixPanelEvent({eventName: CLICKED_BRAND_VIDEO});
};

const SellingProposition = () => (
    <div className="selling-proposition lohp-row">
        <div className="content">
            <h2><I18n k="logged_out_homepage.selling_proposition.title"/></h2>
            <ul>
                <li>
                    <h6><I18n k="logged_out_homepage.selling_proposition.pay_only_sub_title"/></h6>
                    <p><I18n k="logged_out_homepage.selling_proposition.pay_only_details"/></p>
                </li>
                <li>
                    <h6><I18n k="logged_out_homepage.selling_proposition.know_the_price_sub_title"/></h6>
                    <p><I18n k="logged_out_homepage.selling_proposition.know_the_price_details"/></p>
                </li>
                <li>
                    <h6><I18n k="logged_out_homepage.selling_proposition.here_for_you_sub_title"/></h6>
                    <p><I18n k="logged_out_homepage.selling_proposition.here_for_you_details"/></p>
                </li>
            </ul>
        </div>
        <VideoModal imgSrc={imgSrc} pictureData={pictureData} videoUrl={videoUrl} onOpen={reportBi}/>
    </div>
);

export { SellingProposition };
export default SafeComponent(SellingProposition);
